<template>
    <md-field class="w_100 md-has-select" :class="[{ 'md-error': error }]">
        <template v-if="noTable">
            <label >{{ $t("seller.sell.SellModal.SalesDuration") }}</label>
            <TbSelect v-model="value"
					  @md-selected="onSelect"
					  :search-allow="false"
					  :options="options"
					  options-value-field="value"
					  options-display-field="name"
					  :required="required"
					  :disabled="disabled"
            />
            <span v-if="error" class="validation-error">{{ error }}</span>
        </template>
        <template v-else>
            <label>{{ $t("common.duration") }}</label>
            <TbSelect v-model="params.data[params.colDef.field]"
					  @md-selected="onSelect"
					  :search-allow="false"
					  :options="options"
					  options-value-field="value"
					  options-display-field="name"
					  :disabled="disabled"
			/>
        </template>
    </md-field>
</template>
<script>
import {enumDef} from "@/common/enumDefs";

export default {
    props: {
        noTable: { type: Boolean, default: false },
        value: { type: String | Number, default: "" },
        required: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
        error: { type: Boolean, default: "" }
    },
	computed: {
		options() {
			return Object.keys(enumDef.SellDurationOptions.properties)
				.map(enumValue => {
					return {
						value: enumDef.SellDurationOptions.properties[enumValue].value,
						name: this.$t(enumDef.SellDurationOptions.properties[enumValue].key)
					};
				});
		}
	},
    methods: {
        onSelect(value) {
            if (this.noTable) {
                this.$emit("input", value);
            } else {
                let {data, colDef } = this.params;
                data[colDef.field] = value;
            }
        }
    },
};
</script>